import React, { useEffect, useState } from 'react';
import Link from '../../Common/Atoms/Link';
import Paragraph from '../../Common/Atoms/Paragraph';
import Button from '../../Common/Modules/Button';
import CallbackIconTextButton from '../../Common/Modules/CallbackIconTextButton';
import FacebookService from '../../../Services/FacebookService';
import Datadog from '../../../Helpers/Datadog';
import { CustomEventsDatadog, CustomEventsErrorDatadog } from '../../../Config/Datadog';

const { REACT_APP_FACEBOOKAPIID } = process.env;

const Facebook = ({ user, isLoading, onError, tieneClave, vinculadoOtraRed }) => {
    const config = { fbId: REACT_APP_FACEBOOKAPIID };
    const vinculadoFacebook = user?.usuario_facebook_id ? true : false;
    const [estaLogueadoFB, setEstaLogueadoFB] = useState();
    const [nombre, setNombre] = useState();

    useEffect(() => {
        initializeApi();
        execute();
    }, []);

    const initializeApi = () => {
        if (!FB) throw new Error('FB is not defined');
        FB &&
            FB.init({
                appId: config.fbId,
                version: 'v5.0',
                status: true,
                cookie: true,
                xfbml: true,
            });
    };

    const execute = () => {
        FB &&
            FB.getLoginStatus((response) => {
                isLoading(true);
                console.log('Facebook login response: ', response);
                if (response.status == 'connected') {
                    FB.api(
                        '/' + response.authResponse.userID,
                        'GET',
                        {
                            fields: 'first_name,last_name',
                        },
                        (response) => {
                            setNombre(response.first_name + ' ' + response.last_name);
                            setEstaLogueadoFB(true);
                        }
                    );
                }
                isLoading(false);
            });
    }

    const getFbMe = (cb) => {
        FB &&
            FB.api('/me?fields=name,email,age_range,currency,first_name,last_name,gender,locale,birthday,hometown,location', function (response) {
                cb && cb(response);
            });
    }

    const handleLogout = (e) => {
        //console.log("logout click");
        const actualizarLogout = () => {
            isLoading(false);
            setEstaLogueadoFB(false);
        };
        FB && FB.logout(actualizarLogout);
    }

    const handleAsociar = (e, facebookId) => {
        const enabled = !facebookId;
        if (enabled) {
            const asociar = (fbObject) => {
                isLoading(true);
                //Grabo el UsuarioFBId en la Base.
                const usuarioFacebookId = fbObject.id;
                const usuarioFacebookAccessToken = FB.getAuthResponse()['accessToken'];

                const data = {
                    usuarioFacebookId: usuarioFacebookId,
                    accessToken: usuarioFacebookAccessToken,
                };
                FacebookService.AsociarFacebook(data)
                    .then((response) => {
                        if (response && response.code) {
                            if (response.code == '0000' || response.code == '0020') {
                                Datadog.trackCustomEvent(CustomEventsDatadog.vincularRedSocial, { redSocial: 'Facebook' });
                                isLoading(false);
                                setEstaLogueadoFB(true);
                                //TODO: enviar evento a padre porque componente google depende de ésta vinculación
                                //en vez de hacer un reload
                                location.reload();
                            } else {
                                Datadog.trackCustomEventWarning(CustomEventsErrorDatadog.errorVincularRedSocial, { redSocial: 'Facebook' });
                                isLoading(false);
                                const errorMessage = response.code === '0026' ? 'El perfil de Facebook seleccionado ya se encuentra vinculado a otra cuenta' : response.message;
                                onError(errorMessage);
                            }
                        }
                    })
                    .catch((reason) => {
                        console.log(`rejected by ${reason}`);
                        onError(reason);
                        isLoading(false);
                    })
            };

            const fbMe = (response) => {
                if (response.status == 'connected') {
                    getFbMe(asociar);
                }
            };


            const fbMeLogin = (response) => {
                if (response.status == 'connected') {
                    getFbMe(asociar);
                } else {
                    FB.login(
                        function () {
                            console.log('fb.login');
                        },
                        {
                            scope: 'email',
                            return_scopes: true,
                        }
                    );
                }
            };
            FB && FB.Event.subscribe('auth.statusChange', fbMe);
            FB && FB.getLoginStatus(fbMeLogin);
        }
    }

    const handleDesasociar = (e) => {
        isLoading(true);
        FacebookService.DesasociarFacebook()
            .then(() => {
                Datadog.trackCustomEvent(CustomEventsDatadog.desvincularRedSocial, { redSocial: 'Facebook' });
                isLoading(false);
                //TODO: enviar evento a padre porque componente google depende de ésta vinculación
                //en vez de hacer un reload
                location.reload();
            })
            .catch((reason) => {
                Datadog.trackCustomEventWarning(CustomEventsErrorDatadog.errorDesvincularRedSocial, { redSocial: 'Facebook' });
                console.log(`rejected by ${reason}`);
                onError(reason);
                isLoading(false);
            })
    }
    
    return (
        <CallbackIconTextButton
            mod={'--ai-center --mb-32'}
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <path
                        d="M14 0.666687C6.636 0.666687 0.666664 6.63602 0.666664 14C0.666664 20.6547 5.54266 26.1707 11.9173 27.172V17.8534H8.53066V14H11.9173V11.0627C11.9173 7.72135 13.9067 5.87602 16.9533 5.87602C18.412 5.87602 19.9373 6.13602 19.9373 6.13602V9.41602H18.2573C16.6 9.41602 16.084 10.444 16.084 11.4987V14H19.7813L19.1907 17.8534H16.084V27.172C22.4573 26.172 27.3333 20.6534 27.3333 14C27.3333 6.63602 21.364 0.666687 14 0.666687Z"
                        fill="#0074C4"
                    />
                </svg>
            }
            text={
                <>
                    <Paragraph size="--twoxs" mod="--font-bold --arial --mb-8">
                        Facebook
                    </Paragraph>
                    {vinculadoFacebook ? (
                        estaLogueadoFB && nombre != '' ? (
                            <Paragraph size="--fourxs" mod="--arial --mb-8">
                                Conectado como: {nombre}
                            </Paragraph>
                        ) : (
                            <Paragraph size="--fourxs" mod="--arial --mb-8">
                                Cuenta ya vinculada
                            </Paragraph>
                        )
                    ) : estaLogueadoFB ? (
                        <p className="com-paragraph --fourxs --arial --mb-8">
                            Si no sos {nombre} hacé <Link text="click aqui" onClick={handleLogout} />
                        </p>
                    ) : null}
                </>
            }
            button={
                (vinculadoFacebook && (vinculadoOtraRed || tieneClave)) ? //vinculado: vinculada con facebook y también con gmail admite desvincular
                    <Button
                        onClick={handleDesasociar}
                        href={'#'}
                        label="DESVINCULAR"
                        className="state--w100 --mb-0"
                        mod="tertiary"
                        isFirstPositioned={true}
                    /> :
                    !vinculadoFacebook && ( //si no está vinculado
                        <Button
                            onClick={handleAsociar}
                            href={'#'}
                            aria-label="Vincular con la cuenta de Facebook"
                            label="VINCULAR"
                            className="state--w100 --mb-0"
                            mod="tertiary"
                            isFirstPositioned={true}
                        />
                    )}
        />
    );
};

export default Facebook;
